/** Google Maps JavaScript API key (Maps JavaScript API must be enabled in GCP). */
export const GOOGLE_MAPS_API_KEY = String(
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
).trim();

export const hasGoogleMapsKey = () => Boolean(GOOGLE_MAPS_API_KEY);

/** Leaflet fallback — Esri World Street Map (closest free Google-road-map look). */
export const LEAFLET_GOOGLE_STYLE_TILE = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  attribution:
    'Tiles &copy; Esri &mdash; Source: Esri, Garmin, USGS, NOAA',
};

export const DEFAULT_MAP_CENTER = { lat: 17.385, lng: 78.4867 };
